<template>
  <div>
    <BreadCrumd
      :title="'Configuration'"
      :description="'Liste des compétences'"
    />
    <div class="mt-2 mb-4">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-12 col-lg-6">
              <multiselect
                v-model="selectedDomaine"
                :options="domaines"
                :multiple="false"
                :close-on-select="true"
                :clear-on-select="false"
                :preserve-search="true"
                placeholder="Filtrer par domaine"
                label="nom"
                track-by="nom"
                @input="onChangeFilter"
              >
                <template slot="singleLabel" slot-scope="{ option }"
                  ><strong>{{ option.nom }}</strong>
                </template>
              </multiselect>
            </div>
          </div>
        </div>
        <div class="col-md-6 text-right">
          <button
            type="button"
            class="btn btn-secondary mr-4"
            @click.prevent="
              $router.push({ name: 'configuration_dic_home' }).catch(() => {})
            "
          >
            <i class="ion ion-md-cube"></i>
            Dictionnaire
          </button>

          <button type="button" class="btn btn-custom-primary" @click="create">
            <i class="fas fa-plus"></i>
            Nouvelle de compétence
          </button>

          <button
            type="button"
            class="btn btn-danger ml-4"
            @click.prevent="deleteAllSelection"
            v-show="isSelect"
          >
            <i class="fas fa-trash"></i>
            Supprimer
          </button>
        </div>
      </div>
      <div class="row mt-4">
        <div class="col-md-12">
          <DataTable
            ref="datatable"
            :headers="headers"
            @onSelect="onSelectRows"
            @onRowShow="show"
            @onRowEdit="edit"
            @onRowsDelete="deleteRows"
          />
        </div>
      </div>
    </div>
    <Modal ref="modalCompetence" @onInit="refresh" />
  </div>
</template>

<script>
import DataTable from '../components/DataTable.vue';
import URL from '@/http/configuration/dictionnaire/competence';
import Modal from '../components/Modal.vue';

export default {
  data() {
    return {
      title: 'Compétences',
      isSelect: false,
      selectedDomaine: [],
      domaines: [],
      headers: [
        {
          text: 'Domaine de compétence',
          align: 'start',
          sortable: true,
          value: 'domaine',
        },
        {
          text: 'Compétence',
          align: 'start',
          sortable: true,
          value: 'nom',
        },
        {
          text: 'Statut',
          align: 'start',
          sortable: false,
          value: 'statut',
        },
        {
          text: 'Action',
          align: 'center',
          sortable: false,
          value: 'id',
        },
      ],
    };
  },
  metaInfo() {
    return {
      title: this.title,
      titleTemplate: this.titleApp + ' | %s',
    };
  },
  components: {
    DataTable,
    Modal,
  },
  methods: {
    refresh() {
      this.$refs.datatable.loadItems();
    },
    init() {
      this.domaines = [];

      window.axios
        .get(URL.GET_REQUIREMENTS)
        .then((resp) => {
          this.domaines = resp.data.domaine_competences;
        })
        .catch();
    },
    onChangeFilter() {
      let id = this.selectedDomaine ? this.selectedDomaine.id : null;
      this.$refs.datatable.setFilter(id);
      this.$refs.datatable.loadItems();
    },

    create() {
      this.$refs.modalCompetence.create();
    },
    show(id) {
      this.$refs.modalCompetence.show(id);
    },
    edit(id) {
      this.$refs.modalCompetence.edit(id);
    },
    onSelectRows(isSelect) {
      this.isSelect = isSelect;
    },
    deleteAllSelection() {
      this.deleteRows(this.$refs.datatable.idsRowsSelected);
    },
    deleteRows(ids) {
      if (ids && ids.length > 0) {
        this.showConfirmDelete().then((result) => {
          if (result.value) {
            window.axios
              .delete(URL.COMPETENCE, {
                params: {
                  ids: ids,
                },
              })
              .then((resp) => {
                this.showSimpleAlerte('top-end', 'success', resp.data.message);
                this.$refs.datatable.loadItems();
                this.isSelect = false;
              })
              .catch();
          }
        });
      }
    },
  },
  mounted() {
    this.init();
  },
};
</script>
